module.exports = __webpack_public_path__ + "img/introducePageEight_show_three.9eb9cbd0.png";